import { useState } from 'react';
import { useUser } from '@/queries/useUser';
import { useStanRouter } from '@/hooks/useStanRouter';
import { hasActiveSubscription } from '@/features/subscriptions/logic/subscriptionStatus.logic';

interface UseEmptyStateActionsProps {
    variant: 'upgrade' | 'action';
    actionRoute: string;
}

/**
 * Custom hook to handle empty state button actions
 * Manages upgrade flow and navigation logic for empty states
 *
 * @param variant - Whether this is an upgrade or action button
 * @param actionRoute - The route to navigate to for the action variant
 * @returns Object containing button click handler and modal state
 */
export const useEmptyStateActions = ({ variant, actionRoute }: UseEmptyStateActionsProps) => {
    const { user } = useUser();
    const { push } = useStanRouter();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const isUpgradeVariant = variant === 'upgrade';
    const userHasActiveSubscription = hasActiveSubscription(user);

    const handleButtonClick = () => {
        if (isUpgradeVariant) {
            if (!userHasActiveSubscription) {
                push('/subscribe/plan');
            } else {
                setIsModalOpen(true);
            }
        } else {
            push(actionRoute);
        }
    };

    return {
        handleButtonClick,
        isModalOpen,
        setIsModalOpen,
    };
};
